import { useMutation } from '@tanstack/react-query';

import { companySourceTransfersApi } from 'api/inventory/companySourceTransfers';

/**
 * Submits a company source transfer for warehouse location inventory.
 *
 * @param {Object} [options]
 * @param {(data: unknown) => void} [options.onSuccess]
 * @param {(error: Error) => void} [options.onError]
 * @returns {import('@tanstack/react-query').UseMutationResult<unknown, Error, Object>}
 */
export const useCompanySourceTransferMutation = ({ onError, onSuccess } = {}) =>
    useMutation({
        mutationFn: async (params) => {
            const response = await companySourceTransfersApi.createCompanySourceTransfer(params);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to transfer company source');
            }
            return response.data;
        },
        onSuccess,
        onError,
    });
